/* eslint-disable */

import type { BaseResponse, CurrentUser } from '@/types';

const BASE_URL = 'https://id.snapmaker.com';

// 通用请求函数，只需要传递token
async function userRequest<T = unknown>(
  endpoint: string,
  options: {
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
    token?: string;
    data?: Record<string, unknown>;
    headers?: Record<string, string>;
  } = {},
): Promise<T> {
  const { method = 'GET', token, data, headers = {} } = options;

  const requestHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
    ...headers,
  };

  if (token) {
    requestHeaders['Authorization'] = `Bearer ${token}`;
  }

  const requestOptions: RequestInit = {
    method,
    headers: requestHeaders,
  };

  if (data && (method === 'POST' || method === 'PUT')) {
    if (
      requestHeaders['Content-Type'] === 'application/x-www-form-urlencoded'
    ) {
      const params = new URLSearchParams();
      Object.keys(data).forEach((key) => {
        const value = data[key];
        if (value !== undefined && value !== null) {
          params.append(key, String(value));
        }
      });
      requestOptions.body = params.toString();
    } else {
      requestOptions.body = JSON.stringify(data);
    }
  }

  const response = await fetch(`${BASE_URL}${endpoint}`, requestOptions);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
}

// 获取当前用户信息
export async function currentUser(token?: string) {
  return userRequest<BaseResponse<CurrentUser>>(
    '/api/common/accounts/current',
    {
      method: 'GET',
      token,
    },
  );
}

// 退出登录
export async function revokeTokenAPI(token: string): Promise<void> {
  try {
    await userRequest('/api/oauth2/revoke', {
      method: 'POST',
      token,
      data: { token },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  } catch (error) {
    // Token revoke failed
  }
}

// 保留原有的revokeToken函数以兼容现有代码
export async function revokeToken(
  token?: string,
  body?: Record<string, unknown>,
) {
  return userRequest<Record<string, unknown>>('/api/oauth2/revoke', {
    method: 'POST',
    token,
    data: body,
  });
}
